import { Circle } from 'lucide-react';
import type { IResourceStatus } from 'shared/api/services/types';
import { Skeleton } from 'shared/ui/skeleton';
interface ResourceStatusCirclesProps {
  status: IResourceStatus['status'] | 'NO_DATA';
}
type Statuses = {
  id: number;
  status: IResourceStatus['status'];
  color: string;
  cssColor: string;
}[];
const statuses: Statuses = [{
  id: 1,
  status: 'GREEN',
  color: 'fill-status-success text-status-success',
  cssColor: '--status-success'
}, {
  id: 2,
  status: 'YELLOW',
  color: 'fill-status-warning text-status-warning',
  cssColor: '--status-warning'
}, {
  id: 3,
  status: 'RED',
  color: 'fill-status-error text-destructive',
  cssColor: '--status-error'
}, {
  id: 4,
  status: 'NONE',
  color: 'fill-white ',
  cssColor: '--status-white'
}];
function ResourceStatusCircles({
  status
}: ResourceStatusCirclesProps) {
  return <div className="w-[56px] dark:text-white flex flex-row items-center justify-center gap-1 [&_*:nth-child(1)]:animation-delay-0 [&_*:nth-child(2)]:animation-delay-300 [&_*:nth-child(3)]:animation-delay-[600ms] [&_*:nth-child(4)]:animation-delay-[900ms]" data-sentry-component="ResourceStatusCircles" data-sentry-source-file="resource-status-circles.tsx">
      {statuses.map(stat => <Circle key={stat.id} style={status === 'NO_DATA' ? {
      '--fill-color': `hsl(var(${stat.cssColor}))`
    } as any : undefined // Only set style for NO_DATA
    } className={status === stat.status ? stat.color : status === 'NO_DATA' ? 'animate-grow-shrink' : 'fill-white'} size={status === stat.status ? 14.4 : 9.6} />)}
    </div>;
}
const ResourceStatusCirclesSkeleton = () => <div className="flex flex-row items-center justify-center gap-1" data-sentry-component="ResourceStatusCirclesSkeleton" data-sentry-source-file="resource-status-circles.tsx">
    {Array.from({
    length: 4
  }).map((_, index) =>
  // eslint-disable-next-line react/no-array-index-key
  <Skeleton key={index} className="size-3 rounded-full bg-background" />)}
  </div>;
export { ResourceStatusCircles, ResourceStatusCirclesSkeleton };